import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static override targets = ['tabsWrapper']

  declare readonly tabsWrapperTarget: HTMLElement

  executeEvent(event: any) {
    const tabsContent: any = this.tabsWrapperTarget.querySelectorAll('[data-tab-active]')
    const tabsEle: any = this.tabsWrapperTarget.querySelectorAll('[data-tab-heading-active]')
    let activeTab = ''
    event.target.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
    for (let i = 0; i < tabsEle.length; i++) {
      if (tabsEle[i] === event.target) {
        tabsEle[i].setAttribute('data-tab-heading-active', true)
        activeTab = tabsEle[i].getAttribute('data-tab')
      } else {
        tabsEle[i].setAttribute('data-tab-heading-active', false)
      }
    }

    for (let i = 0; i < tabsContent.length; i++) {
      if (tabsContent[i].getAttribute('data-tab-content') === activeTab) {
        tabsContent[i].setAttribute('data-tab-active', true)
      } else {
        tabsContent[i].setAttribute('data-tab-active', false)
      }
    }
  }

  executeKeyUpEvent(e: any) {
    if (e.keyCode === 13) {
      this.executeEvent(e)
    }
  }
}
